import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TableModule } from 'primeng/table';
import { PageDataPanelComponent } from '../../shared/page-layout/page-data-panel.component';

export interface AccountingTaxBreakdownLine {
    description?: string;
    amount?: number;
    taxCode?: string;
    taxRate?: number;
    taxCategory?: string;
    taxableAmount?: number;
    exemptAmount?: number;
    zeroRatedAmount?: number;
    taxAmount?: number;
    totalAmount?: number;
    exemptionReason?: string;
}

@Component({
    selector: 'app-accounting-tax-breakdown-panel',
    standalone: true,
    imports: [CommonModule, TableModule, PageDataPanelComponent],
    template: `
        <app-page-data-panel title="Tax Breakdown">
            <p-table [value]="lines || []" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Description</th>
                        <th>Tax code</th>
                        <th>Category</th>
                        <th class="num">Taxable</th>
                        <th class="num">Exempt</th>
                        <th class="num">Zero-rated</th>
                        <th class="num">Tax</th>
                        <th class="num">Total</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-line>
                    <tr>
                        <td>{{ line.description || '-' }}</td>
                        <td>{{ line.taxCode || defaultTaxCode || '-' }}</td>
                        <td>{{ line.taxCategory || '-' }}</td>
                        <td class="num">{{ money(line.taxableAmount ?? line.amount) }}</td>
                        <td class="num">{{ money(line.exemptAmount) }}</td>
                        <td class="num">{{ money(line.zeroRatedAmount) }}</td>
                        <td class="num">{{ money(line.taxAmount) }}</td>
                        <td class="num">{{ money(line.totalAmount ?? ((line.amount || 0) + (line.taxAmount || 0))) }}</td>
                    </tr>
                    <tr *ngIf="line.exemptionReason">
                        <td colspan="8" class="reason">Exemption reason: {{ line.exemptionReason }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr><td colspan="8">No tax lines available.</td></tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    `,
    styles: [`.num{text-align:right}.reason{color:#64748b;font-size:.85rem}`]
})
export class AccountingTaxBreakdownPanelComponent {
    @Input() lines: AccountingTaxBreakdownLine[] = [];
    @Input() defaultTaxCode?: string;

    money(amount?: number) {
        return Number(amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
}
